import { parsePhoneNumberFromString } from 'libphonenumber-js';
import {
  parseRegistrationAttribution,
  receiveRegistrationAttribution,
  registrationAttributionPayload,
} from './registrationAttributionCore';
import type { StoredRegistrationAttribution } from './registrationAttributionCore';

const STORAGE_KEY = 'chatplus.registration-attribution.v1';
let context: StoredRegistrationAttribution | null = null;
export function captureRegistrationAttribution(): void {
  if (typeof window === 'undefined') return;
  try {
    try {
      context = parseRegistrationAttribution(window.localStorage.getItem(STORAGE_KEY));
    } catch {
      /* 内存兜底。 */
    }
    const received = receiveRegistrationAttribution(
      window.location.href,
      document.referrer,
      context,
    );
    context = received.value;
    if (received.cleanUrl !== window.location.href) {
      try {
        window.history.replaceState(window.history.state, '', received.cleanUrl);
      } catch {
        /* 不阻断启动。 */
      }
    }
    if (context) {
      try {
        window.localStorage.setItem(STORAGE_KEY, JSON.stringify(context));
      } catch {
        /* 内存兜底。 */
      }
    }
  } catch {
    /* 归因不阻断账号功能。 */
  }
}
export function readRegistrationAttribution(phone?: string) {
  const value = registrationAttributionPayload(context);
  if (value && phone) {
    try {
      const country = parsePhoneNumberFromString(phone)?.country;
      if (country) value.country = country;
    } catch {
      /* 国家码缺失不阻断注册。 */
    }
  }
  return value;
}
captureRegistrationAttribution();
